import { useTag } from "./useTag";

export function useTagSubscribersCount(tagId: string | null | undefined) {
  const [tag, meta] = useTag(tagId);

  const count = tag?.data?.subscribers_count || 0;

  return [count, meta] as const;
}
